import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './contains/app/App';
import reportWebVitals from './reportWebVitals';
import './assets/fonts/GolosText-Black.ttf';
import './assets/fonts/GolosText-Bold.ttf';
import './assets/fonts/GolosText-ExtraBold.ttf';
import './assets/fonts/GolosText-Medium.ttf';
import './assets/fonts/GolosText-Regular.ttf';
import './assets/fonts/GolosText-SemiBold.ttf';
import { BrowserRouter } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
